import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { Breadcrumbs, Link, TablePagination, Typography } from "@mui/material";
import RefreshButton from "../../../../../common/components/refresh_button";
import { useMemo } from "react";
import { GenerateQualidadeCronogramaSGQColumns } from "./columns/qualidade_cronogramaSGQ";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { useQualidadeCronogramaSGQListaViewModel } from "../../viewModels/qualidade_cronogramaSGQ_view_model";
import { CronogramaSGQLista } from "../../../domain/models/cronogramaSGQ_lista";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { Header } from "./components/header";
import { CronogramaSGQModal } from "./components/cronogramaSGQ_modal";
import { LegendComponent } from "../../../../../common/components/legend_component";
import { LegendItemComponent } from "../../../../../common/components/legend_item_component";
import { LegendIcon } from "../../../../../common/components/legend_icon";
import { ReportViewerModal } from "../../../../../common/components/report_viewer_modal";
import { ReportModal } from "./components/report_modal";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";

export const CronogramaSGQ_lista = () => {
  const viewModel = useQualidadeCronogramaSGQListaViewModel();

  const QualidadeCronogramaSGQListalColumns = useMemo(() => {
    return GenerateQualidadeCronogramaSGQColumns({
      onActionEditar: viewModel.handleCadastroCronogramaSGQOpenState,
      onActionDeletar: viewModel.handleDeleteCronogramaSGQModalOpenState,
    });
  }, [viewModel.handleCadastroCronogramaSGQOpenState, viewModel.handleDeleteCronogramaSGQModalOpenState]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2 items-center">
              <div className="w-[12rem]">
                <PrimaryButton
                  aria-haspopup="true"
                  onClick={() => viewModel.handleReportModalOpenState(true)}
                  buttonColor="yellow">
                  Relatórios
                </PrimaryButton>
              </div>
              <div className="w-[150px] ">
                <PrimaryButton
                  startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                  onClick={() => viewModel.handleCadastroCronogramaSGQOpenState(null, true)}>
                  Novo
                </PrimaryButton>
              </div>
            </div>
          }
        />
      </PageTopBar>
      <form>
        <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
          <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
            <Link underline="hover" color="inherit">
              Qualidade
            </Link>
            <Typography className="text-primary-green">
              Cronograma e Mudanças do SGQ
            </Typography>
          </Breadcrumbs>
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Cronograma e Mudanças do SGQ</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>
          </div>
          <Header
            onClearFilters={viewModel.handleClearFilters}
            handleTipoPesquisa={viewModel.handleTipoPesquisaChange}
            handleStatus={viewModel.handleStatusChange}
            handlePesquisa={viewModel.handlePesquisaChange}
            pesquisa={viewModel.filters.pesquisa}
            tipoPesquisa={viewModel.filters.tipoPesquisa}
            status={viewModel.filters.status}

          />
          <div className="w-full flex flex-row justify-between items-center">
            <LegendComponent>
              <LegendItemComponent
                icon={<LegendIcon color='green' title='R' />}
                label='Realizada' />
              <LegendItemComponent
                icon={<LegendIcon color='blue' title='DP' />}
                label='Dentro do Prazo' />
              <LegendItemComponent
                icon={<LegendIcon color='red' title='EA' />}
                label='Em Atraso' />
            </LegendComponent>
          </div>
          <StyledDataGrid
            tableName="CronogramaSGQ_lista"
            disableColumnMenu={false}
            getRowId={(row: CronogramaSGQLista) => row.IdCronogramaSGQ}
            columns={QualidadeCronogramaSGQListalColumns}
            loading={viewModel.loading}
            rows={viewModel.cronogramaSGQLista}
            rowCount={viewModel.pagination.totalItems}
            sx={{
              '& .status-header': {
                backgroundColor: '#AFDFD5',
                color: '#000'
              }
            }}
            pinnedColumns={{
              right: ['IdCronogramaSGQ'],
            }}
            autoHeight={true}
            textSize="medio"
            getRowHeight={() => "auto"}
            pageSizeOptions={[10]}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page,
              pageSize: viewModel.pagination.rowsPerPage,
            }} />

          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
        </div>
      </form>

      {/* Modal */}
      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />
      <CronogramaSGQModal
        loading={viewModel.loading}
        onClose={() => viewModel.handleCadastroCronogramaSGQOpenState(null, false)}
        onSubmit={viewModel.handleCronogramaSGQSubmit}
        open={viewModel.CronogramaSGQModal}
        saving={viewModel.saving}
        selectedCronogramaSGQ={viewModel.selectedCronogramaSGQ}
        centroCustoLista={viewModel.centroDeCustoLista}
        onOpenChangeHistory={(id, tabelaTipo) => viewModel.handleOpenChangeHistory(id, tabelaTipo)} />

      <ReportModal
        saving={viewModel.saving}
        open={viewModel.openReportModal}
        reactHookForm={viewModel.hookForm}
        onSubmit={viewModel.handleSubmitReport}
        onClose={() => viewModel.handleReportModalOpenState(false)}
      />

      <ReportViewerModal
        reportViewerState={viewModel.reportViewerState}
      />

      {/* Deletar Registro */}
      <DeleteDialog
        open={viewModel.cronogramaSGQListaDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteCronogramaSGQModalOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteConfirmaCronogramaSGQ} />
    </>
  )
}